import View from './View';
import TestimonialSchema from './schema';
import icon from '@plone/volto/icons/showcase.svg';

const TestimonialBlock = {
    id: 'testimonial',
    title: 'Testimonial',
    view: View,
    icon: icon,
    group: 'wildcard',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    blockSchema: TestimonialSchema,
};

export default TestimonialBlock;